// extracted by css-extract-rspack-plugin
export default {"root":"LYiv_N"};